import { ArrowTopLeftThickIcon } from './ArrowTopLeftThickIcon';

/**
 * author: Michael Irigoyen
 * id D1D2B0DA-2EAD-451B-A9D9-B4C52E16FEDC
 * name arrow-top-left-thick
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowUpLeftThickIcon = ArrowTopLeftThickIcon;
export default ArrowUpLeftThickIcon